import { render, staticRenderFns } from "./CreateNewInvoice.vue?vue&type=template&id=543f5a8a&"
import script from "./CreateNewInvoice.vue?vue&type=script&lang=js&"
export * from "./CreateNewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewInvoice.vue?vue&type=style&index=0&id=543f5a8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports